import { useSupportedValues } from "@/react/features/smp/useSupportedValues";
import DynamicSelectCell from "./DynamicSelectCell";

const TimezoneSelect = (props) => {
  const { options, isFetching } = useSupportedValues("TIME_ZONE_ID");
  return (
    <DynamicSelectCell
      {...props}
      options={options}
      isFetching={isFetching}
      testId={"timezone-select"}
      placeholder={"Select Timezone"}
    />
  );
};

export default TimezoneSelect;
